import { Dialog } from "@mui/material";
import Dropdown from "../../Dropdown/Dropdown";
import Button from "../../Button/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getTranslation } from "../../../utils/getTranslation";
import "./roleChange.css";
import { useGetUserRoles } from "../../../hooks/useGetUserRoles";
import Loading from "../../Loading/Loading";
import Cookie from "../../../services/Cookies";

export const RoleChange = () => {
  const { t } = useTranslation();
  const [payload, setPayload] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const { roles, getUserRoles, setUserRole } = useGetUserRoles(t);

  const closeModal = () => {
    setShowModal(!showModal);
    Cookie.set("tdb_showMultiRole", false);
  }

  const handleInputChange = (e) => {
		const { name, value } = e.target;
		setPayload({ ...payload, [name]: value });
	};

  const saveRole = () => {
    setUserRole(payload.rolId);
    setIsLoading(true);
    setShowModal(!showModal);
    Cookie.set("tdb_showMultiRole", false);
  }

  return (
    <>
      <Loading isLoading={isLoading} />
      <Dialog
        className="change-role-modal"
        open={showModal}
        onClose={closeModal}
      >
        <h2>{getTranslation("role_change_title", t)}</h2>
        <span className="content">
          <p>{getTranslation("role_change_description", t)}</p>
          <Dropdown
            handleChange={handleInputChange}
            onOpen={() => getUserRoles()}
            data={roles}
            value={payload.rolId}
            error={""}
            disabled={false}
            textField='name'
            valueField='id'
            className='col-lg-12 ps-0 pe-0 pe-lg-4 mb-4'
            label={getTranslation("role_change_label", t)}
            name='rolId'
          />
        </span>
        <div className='d-flex gap-4 align-self-center'>
          <Button
            onClick={() => closeModal("cancel")}
            type='secondary'
            children={getTranslation("Cancel", t)}
          />
          <Button
            onClick={saveRole}
            type='primary'
            children={getTranslation("Accept", t)}
          />
        </div>
      </Dialog>
    </>
  )
}
